module.exports = __webpack_public_path__ + "fonts/boxicons.8780613.ttf";